import { render } from "./Modules.vue?vue&type=template&id=aea3d076&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"

import "./Modules.vue?vue&type=style&index=0&id=aea3d076&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-aea3d076"

export default script